<template>
    <div>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader mx-width bg-primary text-light">
            <div class="pageTitle left">Masuk</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule">
            <div class="section form-card-section pt-3">
                <div class="text-center mb-3" style="position: relative">
                    <img
                        :src="require('@/assets/image/logo_header_white.png')"
                        alt="logo"
                        height="40px;"
                    />
                </div>
                <div class="form-card mb-3">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="label mb-1">Nomor Handphone</label>
                            <input
                                type="number"
                                class="form-control form-control-lg"
                                placeholder="0812xxxxxxxx"
                                v-model="auth_data.phone"
                            />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                    </div>
                    <div class="form-group mb-1 mt-1" style="line-height: 145%">
                        <div>
                            Dengan menggunakan {{ VUE_ENV.VUE_APP_NAME }}, saya
                            setuju dengan
                            <a href="Javascript:;">Ketentuan Layanan</a> dan
                            <a href="">Kebijakan Privasi</a>
                            {{ VUE_ENV.VUE_APP_NAME }}
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-6">
                            <router-link
                                :to="{ name: 'auth.register' }"
                                class="btn btn-default btn-block btn-lg"
                                >Daftar</router-link
                            >
                        </div>
                        <div class="col-6">
                            <ButtonLoader
                                :loading="loading.button"
                                :styled="'btn btn-primary btn-block btn-lg'"
                                @click.native="submitValidateLogin()"
                                :type_loader="'spin-only'"
                                :disabled="disabledButtonSubmit"
                                >Masuk</ButtonLoader
                            >
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <router-link
                        :to="{ name: 'care-center' }"
                        style="font-weight: bold"
                    >
                        Butuh Bantuan?
                    </router-link>
                </div>
            </div>
        </div>

        <!-- dialog nomor sudah terdaftar -->
        <Dialog
            ref="dialog_account_not_regsitered"
            :loading="false"
            :title="'Informasi'"
            @confirm="redirectToRegister()"
            :icon="'warning'"
        >
            <p>
                Nomor Handphone <b>{{ auth_data.phone }}</b> belum terdaftar,
                Ayo daftarkan sekarang!
            </p>
        </Dialog>

        <!-- dialog ada sesi login aktif -->
        <Dialog
            ref="dialog_account_active_session"
            :loading="false"
            :title="'Multi Perangkat Terdeteksi'"
            @confirm="directVerfyLogin()"
            :icon="'warning'"
        >
            <p>
                Akun Anda sedang login di perangkat lain dan sesinya akan
                berakhir jika Anda login di perangkat baru. Lanjutkan?
            </p>
        </Dialog>

        <!-- dialog ada sesi login aktif -->
        <Dialog
            ref="dialog_account_deleted"
            :loading="false"
            :title="'Informasi'"
            @confirm="directCareCenter()"
            :icon="'warning'"
        >
            <p>
                {{ dialog_information }}
            </p>
        </Dialog>
    </div>
</template>
<script>
    import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
    export default {
        name: 'auth.login',
        props: ['toast_reference'],
        data() {
            return {
                toast_time: 2000,
                disabledButtonSubmit: true,
                dialog_information: '',
            };
        },
        created() {
            this.$store.commit('SET_TOAST', { show: false });
            this.RESET_AUTH_DATA();
            if (this.isAuth) {
                this.$router.push({ name: 'home' });
            }
        },
        computed: {
            ...mapGetters(['isAuth']),
            ...mapState(['loading', 'toast', 'VUE_ENV']),
            ...mapState('auth', {
                auth_data: state => state.auth_data,
            }),
        },
        methods: {
            ...mapActions('auth', ['login']),
            ...mapMutations('auth', ['RESET_AUTH_DATA']),
            submitValidateLogin() {
                this.$store.commit('SET_LOADING', { button: true });
                this.$store.commit('SET_TOAST', { show: false });
                this.login()
                    .then(response => {
                        // console.log(response);
                        this.$store.commit('SET_LOADING', { button: false });
                        if (response.code == 'ACCOUNT_ACTIVE_SESSION') {
                            let element =
                                this.$refs.dialog_account_active_session.$el;
                            window.$(element).modal('show');
                        } else if (response.code == 'ACCOUNT_SUCCESS') {
                            this.$router.push({
                                name: 'auth.login.verify',
                                params: { back_reference: 'auth.login' },
                            });
                        }
                    })
                    .catch(error => {
                        this.$store.commit('SET_LOADING', { button: false });
                        if (error.data.code == '') {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: error.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        } else if (
                            error.data.code == 'ACCOUNT_NOT_REGISTERED'
                        ) {
                            let element =
                                this.$refs.dialog_account_not_regsitered.$el;
                            window.$(element).modal('show');
                        } else if (error.data.code == 'ACCOUNT_DELETED') {
                            this.dialog_information = error.data.message;
                            let element = this.$refs.dialog_account_deleted.$el;
                            window.$(element).modal('show');
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: error.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        }
                    });
            },
            directVerfyLogin() {
                let element = this.$refs.dialog_account_active_session.$el;
                window.$(element).modal('hide');
                this.$router.push({
                    name: 'auth.login.verify',
                    params: { back_reference: 'auth.login' },
                });
            },
            directCareCenter() {
                let element = this.$refs.dialog_account_deleted.$el;
                window.$(element).modal('hide');
                this.$router.push({
                    name: 'care-center',
                });
            },
            redirectToRegister() {
                let element = this.$refs.dialog_account_not_regsitered.$el;
                window.$(element).modal('hide');
                this.$router.push({
                    name: 'auth.register',
                    params: { phone: this.auth_data.phone },
                });
            },
        },
        watch: {
            'auth_data.phone': function () {
                if (this.auth_data.phone != '') {
                    this.disabledButtonSubmit = false;
                } else {
                    this.disabledButtonSubmit = true;
                }
            },
        },
        mounted() {
            // console.log(typeof this.toast_reference);
            if (this.toast_reference != undefined) {
                // console.log(this.toast_reference);
                this.$store.commit('SET_TOAST', {
                    show: true,
                    message: this.toast_reference.message,
                    tipe: this.toast_reference.tipe,
                    icon: this.toast_reference.icon,
                });
            }
            document.body.classList.add('bg-white');
        },
        destroyed() {
            this.$store.commit('RESET_LOADING');
            this.$store.commit('RESET_TOAST');
        },
        // beforeRouteLeave (to, from, next) {
        //     this.dialogUpdateAPK('hide')
        //     next()
        // },
    };
</script>
